module.exports = new __parcel__URL__("explosion.31069264.png").toString();